<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <input type="hidden" formControlName="location" />
  <div class="row">
    <div class="col-sm-12">
      <p
        class="error error__count text-danger fw-bold"
        [ngClass]="{ 'error--active': errorCount }"
        aria-live="polite"
        >
        @if (multiErrorCount > 1) {
          <ng-container [innerHTML]="tireDescriptionFormTranslations.textErrorCount"
            ></ng-container
            >
          }
        </p>
        <p
          class="error error__fields text-danger fw-bold"
          [ngClass]="{ 'error--active': errorFields }"
          aria-live="polite"
          >
          @if (multiErrorCount > 1) {
            <ng-container [innerHTML]="tireDescriptionFormTranslations.textComplete"></ng-container>
          }
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label for="manufacturer">{{tireDescriptionFormTranslations.textManufacturer}}</label>
          <div class="select-wrapper">
            <select
              name="manufacturer"
              id="manufacturer"
              class="custom-select wrapText"
              formControlName="manufacturer"
              [attr.aria-required]="tire.location !== 'SP'"
              >
              <option value="">{{tireDescriptionFormTranslations.textSelect}}</option>
              @if (tire.location === 'SP') {
                <option value="[Compact Spare]">[Compact Spare]</option>
              }
              @for (m of manufacturers; track m) {
                <option [value]="m">{{ m }}</option>
              }
            </select>
          </div>
          <p class="text-danger fw-bold" aria-atomic="true" aria-live="polite">
            @if (manufacturer.dirty && !multiErrors && (manufacturer.errors?.invalidValue || manufacturer.errors?.required)) {
              {{tireDescriptionFormTranslations.textEnterManufacturerContinue}}
            }
          </p>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="size"> {{tireDescriptionFormTranslations.textTireSize}} <span class="visually-hidden">(inches)</span> </label>
          <div class="select-wrapper">
            <select
              name="size"
              id="size"
              class="custom-select wrapText"
              formControlName="size"
              [attr.aria-required]="tire.location !== 'SP'"
              >
              <option value="">{{tireDescriptionFormTranslations.textSelect}}</option>
              @for (s of tiresSizes; track s) {
                <option [value]="s">{{ s }}</option>
              }
            </select>
          </div>
          <p class="text-danger fw-bold" aria-atomic="true" aria-live="polite">
            @if (size.dirty && !multiErrors && (size.errors?.invalidValue || size.errors?.required)) {
              {{tireDescriptionFormTranslations.textEnterSize}}
            }
          </p>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="tread"> {{tireDescriptionFormTranslations.textTreadDepth}} <span class="visually-hidden">(inches)</span></label>
          <div class="select-wrapper">
            <select
              name="tread"
              id="tread"
              class="custom-select wrapText"
              formControlName="tread"
              [attr.aria-required]="tire.location !== 'SP'"
              >
              <option value="">{{tireDescriptionFormTranslations.textSelect}}</option>
              @for (d of treadDepths; track d) {
                <option [value]="d">{{ d }}</option>
              }
            </select>
          </div>
          <p class="text-danger fw-bold" aria-atomic="true" aria-live="polite">
            @if (tread.dirty && !multiErrors && (tread.errors?.invalidValue || tread.errors?.required)) {
              {{tireDescriptionFormTranslations.textEnterTreadDepth}}
            }
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-10">
        @if (tire.location !== 'SP') {
          <div class="custom-control custom-checkbox flex flex-row mb-3">
            <input type="checkbox" class="custom-control-input excludes__input" id="mark-all-tires-the-same" formControlName="markTheSame"/>
            <label class="custom-control-label excludes__label ms-2 align-middle" for="mark-all-tires-the-same"
              >{{tireDescriptionFormTranslations.labeMarkAllTire}}</label
              >
            </div>
          }
          <p [innerHTML]="tireDescriptionFormTranslations.textProvideTireDamage"></p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-8 col-lg-7">
          <div class="form-group">
            <label for="comments">{{tireDescriptionFormTranslations.ariaLabelTireDamageDescription}}</label>
            <textarea
              [attr.aria-label]="tireDescriptionFormTranslations.ariaLabelTireDamageDescription"
              name="comments"
              id="comments"
              rows="2"
              class="form-control"
              maxlength="50"
              formControlName="comments"
              (input)="filterCommentValues()"
              [ngClass]="{ 'ng-invalid': form.getError('commentsRequired') }"
              [attr.aria-required]="form.errors?.commentsRequired"
            ></textarea>
            <p class="text-danger fw-bold" aria-atomic="true" aria-live="polite">
              @if (comments.dirty && !multiErrors && form.errors?.commentsRequired) {
                {{tireDescriptionFormTranslations.textEnterDamageDes}}
              }
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="wrapper">
          <div class="form-group">
            <label for="damageCost">{{tireDescriptionFormTranslations.labelCost}}</label>
            <div class="input-wrapper">
              <span class="dollar-sign" [ngClass]="isFrenchCanadian ? 'canadian' : 'american'">$</span>
              @if (!isFrenchCanadian) {
                <input
                  type="text"
                  id="damageCost"
                  class="form-control american-input"
                  formControlName="damageCost"
                  mask="separator.2"
                  thousandSeparator=","
                  separatorLimit="100000"
                  (blur)="formatCurrency()"
                  [ngClass]="{ 'ng-invalid': form.getError('costRequired') }"
                  [attr.aria-required]="form.errors?.costRequired"
                  />
              }
              @if (isFrenchCanadian) {
                <input
                  type="text"
                  id="damageCost"
                  class="form-control canadian-input"
                  formControlName="damageCost"
                  mask="separator.2"
                  thousandSeparator=" "
                  decimalMarker=","
                  separatorLimit="100000"
                  (blur)="formatCurrency()"
                  [ngClass]="{ 'ng-invalid': form.getError('costRequired') }"
                  [attr.aria-required]="form.errors?.costRequired"
                  />
              }
            </div>
            <p class="text-danger fw-bold" aria-atomic="true" aria-live="polite">
              @if (damageCost.dirty && !multiErrors && form.errors?.costRequired) {
                {{tireDescriptionFormTranslations.textEnterCostContinue}}
              }
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-2">
          <h5 class="content-card-title">{{tireDescriptionFormTranslations.labelTirePhoto}}</h5>
          <div class="content-card-subtitle mb-1">{{tireDescriptionFormTranslations.textSelect5}}</div>
          <div class="tire-photo-selection-links">
            <button
              type="button"
              id="tire-new-photo"
              class="btn btn-link p-0"
              data-track-name="Upload new"
              [attr.aria-label]="tireDescriptionFormTranslations.btnUploadNew"
              (click)="selectPhotos()"
              >
              {{tireDescriptionFormTranslations.btnUploadNew}}
            </button>
            @if (existingPhotoList?.length) {
              <span class="divider">|</span>
              <button
                type="button"
                id="tire-existing-photo"
                class="btn btn-link p-0"
                data-track-name="Select existing"
                [attr.aria-label]="tireDescriptionFormTranslations.btnSelectExisting"
                (click)="showExistingModal()"
                >
                {{tireDescriptionFormTranslations.btnSelectExisting}}
              </button>
            }
          </div>
          @if (errMsg) {
            <div class="mt-2 error-msg">{{errMsg}}</div>
          }
          <div class="photos-container photos-no-location mb-3">
            <app-photos-card
              [photoList]="uploadedImgList"
              [flowName]="currTirelocation"
              (photosCardDeletionStatus)="actionBarUpdatesFromPhotosCard($event)"
            ></app-photos-card>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-2 actions">
          <button
            class="btn btn-outline-primary"
            type="submit"
            data-track-name="Add Changes"
            >
            {{tireDescriptionFormTranslations.btnAddChanges}}
          </button>
          <button
            class="d-block d-md-inline-block btn btn-link ms-md-3 cancel"
            type="button"
            data-track-name="Cancel"
            (click)="onCancel()"
            >
            {{tireDescriptionFormTranslations.btnCancel}}
          </button>
        </div>
      </div>
    </form>

    <app-existing-photos-modal
      [origninalPhotoList]="existingPhotoList"
      [maxPhotoSelection]="5"
      (selectedExistingImages)="photosFromExistingModal($event)">
    </app-existing-photos-modal>
